export default "__VITE_ASSET__0dd42f94__"